import axios from "axios";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiHeader } from "./ApiHeader";
import {
  IS_LOADING,
  PLAYER_ACC_LIST_SUCCESS,
  PLAYER_ACC_LIST_ERROR,
  SERIES_DROP_LIST_SUCCESS,
  SERIES_DROP_LIST_ERROR,
  MATCH_DROP_LIST_SUCCESS,
  MATCH_DROP_LIST_ERROR,
  PLAYER_ACC_UPDATE_SUCCESS,
  PLAYER_ACC_UPDATE_ERROR,
} from "./Type";
import { apiVersion } from "src/utils/apiVersion";

export const GetPlayerAccumulatorListAction =
  (page, limit, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    await axios
      .post(
        `${baseUrlPostGres()}/admin/${
          apiVersion.v1
        }/playeraccumulator/player_list?page=${page}&limit=${limit}`,
        data,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: PLAYER_ACC_LIST_SUCCESS,
          payload: response,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: PLAYER_ACC_LIST_ERROR,
          payload: errors,
        });
      });
  };

export const ResetPlayerAccumulatorListAction = () => async (dispatch) => {
  dispatch({
    type: PLAYER_ACC_LIST_SUCCESS,
    payload: {},
  });
};

export const SeriesListAction = (type) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .get(
      `${baseUrlPostGres()}/admin/${
        apiVersion.v1
      }/playeraccumulator/series_list?type=${type}`,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      dispatch({
        type: SERIES_DROP_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: SERIES_DROP_LIST_ERROR,
        payload: errors,
      });
    });
};

export const MatchListAction = (data) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(
      `${baseUrlPostGres()}/admin/${
        apiVersion.v1
      }/playeraccumulator/match_list`,
      data,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      dispatch({
        type: MATCH_DROP_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: MATCH_DROP_LIST_ERROR,
        payload: errors,
      });
    });
};

export const ResetMatchListAction = () => async (dispatch) => {
  dispatch({
    type: MATCH_DROP_LIST_SUCCESS,
    payload: {},
  });
};

export const UpdatePlayerAction = (data) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(
      `${baseUrlPostGres()}/admin/${
        apiVersion.v1
      }/playeraccumulator/update_player`,
      data
    )
    .then((response) => {
      dispatch({
        type: PLAYER_ACC_UPDATE_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: PLAYER_ACC_UPDATE_ERROR,
        payload: errors,
      });
      console.log("user list error", errors);
    });
};

export const ResetUpdatePlayerAction = () => async (dispatch) => {
  dispatch({
    type: PLAYER_ACC_UPDATE_SUCCESS,
    payload: {},
  });
};
